import { useEffect, useState } from 'react'

export function useImageLoader(picture: string | null | undefined) {
	const [isLoaded, setIsLoaded] = useState(false)

	useEffect(() => {
		if (!picture) return

		const img = new Image()
		img.src = picture

		img.onload = () => setIsLoaded(true)
		img.onerror = () => setIsLoaded(false)
	}, [picture])

	return isLoaded
}
